<template>
    <div>
        <div class="mt-3 font-weight-bold" v-if="weekBeforeEnd <= 1">
            <v-alert
                prominent
                type="error">
                You have until midnight on {{ cutoffDate }} to upload your before and after photos.<br>
                You must upload your photos to qualify for Major Prize judging.
            </v-alert>
        </div>
        <v-container
            fluid
            grid-list-md
        >
            <v-layout row wrap class="image-container">
                <v-flex v-for="(image, n) in images" :key="n"
                        xs4
                >
                    <image-upload :image="image"></image-upload>
                </v-flex>
            </v-layout>
        </v-container>
        <div class="photo-btn-container" v-if="currentWeek > totalWeeks/2">
            <v-btn-toggle mandatory v-model="photo_type" class="xs12 ma-0 before-after-btns">
                <v-btn color="primary" text value="0" class="ma-0">Before</v-btn>
                <v-btn color="primary" text value="1" class="ma-0">After</v-btn>
            </v-btn-toggle>
        </div>
      <div class="d-flex justify-center mt-4"><v-btn v-on:click="updateTsAndCs"><v-icon color="#555555" light>mdi-settings</v-icon></v-btn></div>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import moment from "moment";
import ImageUpload from './ImageUpload'

export default {
name: "PhotoDisplay",
    components: {
        ImageUpload
    },
  methods: {
    updateTsAndCs () {
      this.$store.dispatch('challenge/resetTerms')
    }
  },
    computed: {
        photo_type: {
            get () {
                return this.$store.state.data.photoType
            },
            set (value) {
                return this.$store.dispatch('data/setPhotoType', value)
            }
        },
        ...mapGetters({
            images: 'data/images',
            currentWeek: 'challenge/currentWeek',
            totalWeeks: 'challenge/weeks',
        }),
        ...mapState({
            cutoffDate: state => moment(state.challenge.challenge.cutoff_date, 'DD/MM/YYYY').subtract(1, "days").format('dddd Do MMMM YYYY'),
            weekBeforeEnd: state => {
                var now = moment()
                var end = moment(state.challenge.challenge.end_date, 'DD/MM/YYYY')
                var weekBeforeEnd = end.diff(now, 'week') + 1
                return weekBeforeEnd
            }
        })
    }
}
</script>

<style lang="scss">
    .image-container {
        padding-top: 10px;
    }
    @media only screen
    and (max-device-width: 375px) {
        .image-container {
            padding: 10px;
        }
    }

    .photo-btn-container {
      margin-top: 1em;
      .v-btn-toggle {
        display: flex;
        .v-btn {
          flex-basis: 0;
          flex-grow: 1;
        }
      }
    }

</style>
